import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["valuesInput", "previewContainer"]

  connect() {
    this.updateAllPreviews()
  }

  updateAllPreviews() {
    if (!this.hasValuesInputTarget) return

    const sectionIndex = this.getSectionIndex()
    const questionIndex = this.getQuestionIndex()
    const values = this.valuesInputTarget.value
    const selectedType = this.getSelectedType()

    if (!selectedType) return

    // Find all preview containers for this question
    const previewContainers = this.element.querySelectorAll('[data-type="values"]')

    previewContainers.forEach(container => {
      const containerType = this.getContainerType(container)
      this.updatePreview(container, containerType, values, sectionIndex, questionIndex)
    })
  }

  getContainerType(container) {
    const parent = container.closest('.card')
    if (!parent) return null

    const radio = parent.closest('label')?.querySelector('input[type="radio"]')
    return radio?.value
  }

  getSectionIndex() {
    const match = this.valuesInputTarget.name?.match(/sections\[(\d+)\]/) ||
      this.valuesInputTarget.id?.match(/response-values-(\d+)-/)
    return match ? match[1] : '0'
  }

  getQuestionIndex() {
    const match = this.valuesInputTarget.name?.match(/questions\[(\d+)\]/) ||
      this.valuesInputTarget.id?.match(/response-values-\d+-(\d+)/)
    return match ? match[1] : '0'
  }

  getSelectedType() {
    const field = this.element.closest('.field')
    const checked = field?.querySelector('input[name*="response_type"]:checked')
    return checked?.value || 'bool'
  }

  updatePreview(container, type, values, sectionIndex, questionIndex) {
    const valuesArray = values.split(/[;]/).map(v => v.trim()).filter(v => v)

    switch (type) {
      case 'bool':
        this.updateBoolPreview(container, valuesArray, sectionIndex, questionIndex)
        break
      case 'text':
        this.updateTextPreview(container, valuesArray, sectionIndex, questionIndex)
        break
      case 'select':
        this.updateSelectPreview(container, valuesArray, sectionIndex, questionIndex)
        break
      case 'multi_select':
        this.updateMultiSelectPreview(container, valuesArray, sectionIndex, questionIndex)
        break
      case 'range':
        this.updateRangePreview(container, valuesArray, sectionIndex, questionIndex)
        break
    }
  }

  updateBoolPreview(container, values, sectionIndex, questionIndex) {
    const trueLabel = values[0] || 'Tak'
    const falseLabel = values[1] || 'Nie'
    const name = `sections[${sectionIndex}][questions][${questionIndex}][response]`

    container.innerHTML = `
      <input aria-label="${trueLabel}" class="btn" name="${name}" type="radio" value="${trueLabel}">
      <input aria-label="${falseLabel}" class="btn" name="${name}" type="radio" value="${falseLabel}">
      <input class="btn btn-square" data-action="click->radio-reset#clear" type="reset" value="×">
    `
  }

  updateTextPreview(container, values, sectionIndex, questionIndex) {
    const placeholder = values[0] || 'Wpisz odpowiedź...'
    const name = `sections[${sectionIndex}][questions][${questionIndex}][response]`

    container.innerHTML = `
      <input class="input input-bordered w-full" name="${name}" placeholder="${placeholder}" type="text">
    `
  }

  updateSelectPreview(container, values, sectionIndex, questionIndex) {
    const name = `sections[${sectionIndex}][questions][${questionIndex}][response]`

    if (values.length === 0) {
      values = ['Opcja 1', 'Opcja 2', 'Opcja 3']
    }

    const buttons = values.map(opt =>
      `<input aria-label="${opt}" class="btn" name="${name}" type="radio" value="${opt}">`
    ).join('')

    container.innerHTML = `
      ${buttons}
      <input class="btn btn-square" data-action="click->radio-reset#clear" type="reset" value="×">
    `
  }

  updateMultiSelectPreview(container, values, sectionIndex, questionIndex) {
    const name = `sections[${sectionIndex}][questions][${questionIndex}][response]`

    if (values.length === 0) {
      values = ['Opcja 1', 'Opcja 2', 'Opcja 3']
    }

    const buttons = values.map(opt =>
      `<input aria-label="${opt}" class="btn" name="${name}" type="checkbox" value="${opt}">`
    ).join('')

    container.innerHTML = `
      ${buttons}
      <input class="btn btn-square" data-action="click->radio-reset#clear" type="reset" value="×">
    `
  }

  // updateRangePreview(container, values, sectionIndex, questionIndex) {
  //   const min = parseInt(values[0]) || 0
  //   const max = parseInt(values[1]) || 5
  //   const name = `sections[${sectionIndex}][questions][${questionIndex}][response]`
  //
  //   const spans = Array.from({length: max - min + 1}, (_, i) =>
  //     `<span>${min + i}</span>`
  //   ).join('')
  //
  //   container.innerHTML = `
  //     <input class="range range-sm range-primary" max="${max}" min="${min}" name="${name}" type="range" value="${min}">
  //     <div class="flex justify-between px-2 mt-1 text-xs">${spans}</div>
  //   `
  // }

  updateRangePreview(container, values, sectionIndex, questionIndex) {
    const min = parseInt(values[0]) || 0
    const max = parseInt(values[1]) || 5
    const name = `sections[${sectionIndex}][questions][${questionIndex}][response]`

    // Create radio buttons HTML
    let radioButtons = ''
    for (let i = min; i <= max; i++) {
      radioButtons += `<input class="btn" type="radio" name="${name}" aria-label="${i}" value="${i}">`
    }

    // Add reset button
    const resetButton = `<input class="btn btn-square" type="reset" value="×" data-action="click->radio-reset#clear">`

    // Generate the complete HTML structure
    container.innerHTML = `
    <div class="filter" data-controller="radio-reset" data-type="values" data-section="${sectionIndex}" data-question="${questionIndex}">
      ${radioButtons}
      ${resetButton}
    </div>
  `
  }
}
